module.exports = "pegasus_template/assets/themecapture1/small/9.png";